import React, { Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import TmmMain from "../components/TMM/TmmMain";
import Loading from "../common-components/Loader";
import DetailPagePdf from "../components/Detail page/DetailPagePdf";
import PageNotFound from "../common-components/NotFound/PageNotFound";
import TitleDetails from "../components/Title Details/TitleDetails";
import TmmExport from "../components/TMM/tmmexport";
import TmmexportSmallVersion from "../components/TMM/TmmexportSmallVersion";


const AdminLogin = React.lazy(() => import("../components/auth/index"));
const Layout = React.lazy(() => import("./layout"));
const IndyBoData = React.lazy(
  () => import("../components/IndyBoData/IndyBoData")
);

export const routes = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "",
        element: (
          <ProtectedRoute
            element={
              <Suspense
                fallback={
                  <Loading isLoading={true} height={80} width={80} color="#15223F" />
                }
              >
                <TmmMain />
              </Suspense>
            }
          />
        ),
      },
      {
        path: "/details/:id?",
        element: (
          <ProtectedRoute
            element={
              <Suspense
                fallback={
                  <Loading isLoading={true} height={80} width={80} color="#15223F" />
                }
              >
                <DetailPagePdf />
              </Suspense>
            }
          />
        ),
      },
      {
        path: "/title-details/:id?",
        element: (
          <ProtectedRoute
            element={
              <Suspense
                fallback={
                  <Loading isLoading={true} height={80} width={80} color="#15223F" />
                }
              >
                <TitleDetails />
              </Suspense>
            }
          />
        ),
      },
      {
        path: "/Tmm-export",
        element: (
          <ProtectedRoute
            element={
              <Suspense
                fallback={
                  <Loading isLoading={true} height={80} width={80} color="#15223F" />
                }
              >
                <TmmExport />
              </Suspense>
            }
          />
        ),
      },
      {
        path: "/indybodata",
        element: (
          <ProtectedRoute
            element={
              <Suspense
                fallback={
                  <Loading
                    isLoading={true}
                    height={80}
                    width={80}
                    color="#15223F"
                  />
                }
              >
                <IndyBoData />
              </Suspense>
            }
          />
        ),
      },
      // {
      //   path: "/inventory-report",
      //   element: (
      //     <ProtectedRoute
      //       element={
      //         <Suspense
      //           fallback={
      //             <Loading isLoading={true} height={80} width={80} color="#15223F" />
      //           }
      //         >
      //           <TmmexportSmallVersion/>
      //         </Suspense>
      //       }
      //     />
      //   ),
      // },
    ],
  },
  {
    path: "*",
    element: (
      <Suspense
        fallback={
          <Loading isLoading={true} height={80} width={80} color="#15223F" />
        }
      >
        <PageNotFound />
      </Suspense>
    ),
  },
]);
